import * as types from "../mutation-types";
import axios from "axios";
import store from "~/store";
import Vue from 'vue';
// state
export const state = {
    current_page: "",
    last_page: "",
    loading: true,
    name: null,
    tables: [
        {
            name: "",
            columnFilterValue: {},
            allFields: [],
            limit: 10,
            page: 1,
            order: "asc",
            hasItems: false,
        }
    ],

    filters:{
        where: {

        }
    }

};

// getters
export const getters = {
  tables: state => state.tables,
  loading: state => state.loading,
  name: state => state.name,
  filters: state => state.filters

};

// mutations
export const mutations = {
    [types.TABLES](state, { data }) {
        Vue.set(state, 'tables', data);
    },

    [types.UPDATE_TABLE](state, { index, table }) {
        let tables = state.tables;
        tables[index] = table;
        Vue.set(state, 'tables', tables);
    },

    [types.ADD_TABLE](state, { table }) {
        let tables = state.tables;
        tables.push(table);
        Vue.set(state, 'tables', tables);
    },

    [types.LOADING](state, { loading }) {
        Vue.set(state, 'loading', loading);
    },

    [types.ADD_FILTER](state , { where }){
        let filters = state.filters;
        filters.where = {
            ...filters.where,
            ...where
        };
        Vue.set(state, 'filters', filters);
    },

    [types.CLEAR_FILTERES](state , {  }){
        let filters = state.filters;
        filters.where = {};
        Vue.set(state, 'filters', filters);
    },
    
    [types.PAGE_NAME](state , { name }){
        Vue.set(state, 'name', name);
    }

};

// actions
export const actions = {

    updateTables({ commit, state }, payload) {

        let tableTemp = {
            name: payload.name,
            fields: payload.fields,
            columnFilterValue: payload.columnFilterValue,
            allFields: payload.allFields,
            limit: payload.rows,
            page: payload.page,
            order: payload.order,
            hasItems: payload.items.length > 0,
        }
        

        let index =  state.tables.findIndex(table => table.name === payload.name);    

        if(index != -1){
            tableTemp.hasItems = true;
            commit(types.UPDATE_TABLE, {
                index: index,
                table: tableTemp
            })
        }else{
            tableTemp.defaultFields = payload.fields;
            commit(types.ADD_TABLE, {
                table: tableTemp
            });
        }
    },
    toggleLoading({ commit, state }, payload) {
        commit(types.LOADING, { loading: !state.loading });
    },
    updateLoading({ commit, state }, payload) {
        commit(types.LOADING, { loading: payload.loading });
    },

    addFilterWhere({ commit, state }, payload) {
        commit(types.ADD_FILTER, { where: payload });
    },

    clearFilters({ commit, state }) {
        commit(types.CLEAR_FILTERES, { });
    },
    
    setName({ commit, state }, payload) {
        commit(types.PAGE_NAME, { name: payload.name });
    }
};
